<template>
	<div class="page">
		<!-- your page -->
		<div class="footNav">
			<div class="fixation">
				<div class="footNavLeft">
					<div class="unit" v-for="(item,index) in footNav" :key="index">
						<div class="unitMain">{{item.main}}</div>
						<div class="unitLine" v-for="(tab,tabIndex) in item['tab']" :key="tabIndex" @click="goArticle" :data-id="tab.id">
							·{{tab.title}}
						</div>
					</div>
				</div>
				<div class="footNavRight">
					<div class="qrcode">
						<div class="qrcodeBox">
							<img :src="qrcode" alt="">
						</div>
						<div class="qrcodeWord">
							{{shop_name}}移动端
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="copyright">
			<div class="about">
				<div class="aboutBox" :style="'width:'+100*about.length+'px'">
					<div class="aboutUnit" v-for="item in about" :data-id="item.id" @click="goArticle">
						{{item.title}}
					</div>
				</div>
			</div>
			<div class="copyrightWord">
				 <a href="http://beian.miit.gov.cn/" target='_blank'>{{copyright}}</a>&nbsp;&nbsp;<img src="../assets/index/police.png" alt="">&nbsp;{{police}}
				 <!-- <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91130293MA093F9MX8-SAIC_SHOW_10000091130293MA093F9MX81599214172494&signData=MEYCIQCCUO1MFdP0XDW5VCrXdWQnIy58p4+L9ByKkh+CrBumWAIhAJQmNCYZRpXoY+/jGxVoSJn+b1NJg8TapWiK+mcQuq6l" target="_blank"><img src="../assets/index/dz.png" style="height:21px;" alt=""></a> -->
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'pubFoot',
		data(){
			return {
				footNav:[],
				qrcode:"",
				about:[],
				copyright:"",
				police:"",
				shop_name:""
			}
		},
		methods:{
			goArticle(e){
				var id = e.target.dataset.id
				this.$router.push({path:"/article",query:{aid:id,type:"article"}})
				this.$router.go(0)
			},
			fetchData(){
				var data = {
					method:"articles.getFooterAritic"
				}
				var that = this
				this.request(data,(res)=>{
					if(res.status){
						var list = res.data[0]
						for (let i in list) {
							var obj = {
								"main":list[i].type_name,
								"tab":list[i].list
							}
							that.footNav.push(obj)
						}
						that.about = res.data[1].list
					}else{
						that.globalTest('articles.getFooterAritic','error',res.msg,res.data)
					}
				})
			},
			fetchCopyRight(){
				var data = {
					method:"config.config"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.copyright = res.data.copyrightWord
						that.police = res.data.police
						that.qrcode = res.data.qrcode
						that.shop_name = res.data.shop_name
					}else{
						that.globalTest('config.config','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
			this.fetchCopyRight()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.footNav{
		width:100%;
		height: 220px;
	}
	.footNavLeft{
		width: 900px;
		height: 160px;
		float: left;
		margin-top: 50px;
	}
	.unit{
		width: 180px;
		height: 100%;
		float: left;
	}
	.unitMain{
		width: 100%;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
	}
	.unitLine{
		width: 100%;
		height: 26px;
		line-height: 26px;
		font-size: 14px;
		color: #838383;
		cursor: pointer;
	}
	.unitLine:hover{
		color: #036DEE;
	}
	.footNavRight{
		width: 300px;
		height: 160px;
		float: left;
		margin-top: 50px;
		border-left: 1px solid #B3B3B3;
		box-sizing: border-box;
	}
	.qrcode{
		width: 100%;
		height: 100%;
	}
	.qrcodeBox{
		width: 120px;
		height: 120px;
    margin: 0 auto;
	}
	.qrcode img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.qrcodeWord{
		width: 100%;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
	}
	.copyright{
		width: 100%;
		height: 80px;
	}
	.about{
		width: 100%;
		height: 40px;
		padding-top: 13px;
		box-sizing: border-box;
	}
	.aboutBox{
		height: 24px;
		margin: 0 auto;
		line-height: 24px;
		font-size: 0px;
		letter-spacing: -6px;
		color: #838383;
	}
	.aboutUnit{
		width: 100px;
		height: 100%;
		display: inline-block;
		vertical-align: top;
		font-size: 14px;
		letter-spacing: normal;
		border-right: 1px solid #B3B3B3;
		text-align: center;
		box-sizing: border-box;
		cursor: pointer;
	}
	.aboutUnit:hover{
		color: #036DEE;
	}
	.aboutUnit:last-child{
		border: none;
	}
	.copyrightWord{
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-align: center;
	}
  .copyrightWord a{
    color: #000000;
  }
  .copyrightWord a:hover{
    color: #036DEE;
  }
</style>
